<label [for]="id" [ngClass]="['control-label', _labelClass]">Agence {{ _mandatory? '*' : '' }}:</label>
<div [ngClass]="_fieldClass">
	<div class="input-group col-sm-12 ng-scope">
	 	<select  [name]="id" [id]="id"
	 		[disabled]="disabled"
			[(ngModel)]="selectedAgenceId"
			(ngModelChange)="onSelectionChange()"
			class="form-control" 
			>
			<option *ngIf="wildcardOptionLabel && agences && agences.length > 1" [ngValue]="null" class="tip">{{ wildcardOptionLabel }}</option>
			<option *ngFor="let agence of agences" [ngValue]="agence.id">{{ agence.nom }}</option>
		</select>
		<div *ngIf="wildcardOptionLabel" class="input-group-addon">
			<a class="" href="#" onclick="return false;" title="Retirer le choix d'agence" (click)="onCancelSelection()">
				<span [ngClass]="'fa fa-minus-circle fa-lg' + (disabled ? ' disabled' : '' )"></span>
			</a>
		</div>
	</div>
</div>